import {
  ENotEditableReason,
  EProgrammedMessageType,
  TMessageContentRule,
  TMessageSchedule,
} from '../messages/_components/programmed-message.type'
import { EValidationType, TMedEventProperty } from 'src/types/med-event'
import { TPatientLocale, TLabel } from 'src/types/locales'

export const ETimelineElementType = {
  MESSAGE: EProgrammedMessageType.MESSAGE,
  COMPLEX_MESSAGE: EProgrammedMessageType.COMPLEX_MESSAGE,
  MED_EVENT: 'MED_EVENT',
  CHATBOT: 'CHATBOT',
} as const

// eslint-disable-next-line no-redeclare
export type ETimelineElementType = (typeof ETimelineElementType)[keyof typeof ETimelineElementType]

export type TTimelineMessageElement = {
  id: number
  type: EProgrammedMessageType
  name: string
  contents: Array<Partial<Record<TPatientLocale, string>>>
  profileRules?: TMessageContentRule[]
  schedule: TMessageSchedule
  isEditable: boolean
  notEditableReason: ENotEditableReason | null
}

export type TTimelineMedEventFormConfiguration = {
  properties: TMedEventProperty[]
  isRepeatable: boolean
  validationType: EValidationType
}

export type TFollowupTimeline = {
  intlName: TLabel
  timelineMedEvents?: Array<{
    label: TLabel
    formConfiguration: TTimelineMedEventFormConfiguration
    messages: Array<TTimelineMessageElement | TTimelineChatbotElement>
  }>
}

export type TTimelineMedEventElement = {
  type: typeof ETimelineElementType.MED_EVENT
  medEventLabel: TLabel
  formConfiguration: TTimelineMedEventFormConfiguration
}

export type TTimelineChatbotElement = {
  id: number
  type: typeof ETimelineElementType.CHATBOT
  name: string
  isActive: boolean
  nodeCount?: number
  schedule: {
    durationDiff: string
    atTime?: string
    avoidHolidays?: boolean
  }
  options?: {
    automaticEnd?: { expireDuration?: string } | null
    automaticRelaunchDelay?: string | null
    showUnreachedPatientInDashboardDelay?: string | null
  }
}

export type TTimelineElement = TTimelineMedEventElement | TTimelineMessageElement | TTimelineChatbotElement
export type TTimeline = Array<TTimelineElement[]>
